/**
 * Viewport height utility for better mobile support
 * Handles dynamic viewport height changes on mobile devices
 */
export var initializeViewportHeight = function () {
    // Function to set CSS custom property for viewport height
    var setViewportHeight = function () {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
    };
    // Set initial value
    setViewportHeight();
    // Update on resize (throttled for performance)
    var resizeTimer;
    var handleResize = function () {
        if (resizeTimer)
            clearTimeout(resizeTimer);
        resizeTimer = setTimeout(setViewportHeight, 100);
    };
    // Update on orientation change (mobile devices)
    var handleOrientationChange = function () {
        // Delay to ensure viewport has updated
        setTimeout(setViewportHeight, 500);
    };
    // Add event listeners
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);
    // Return cleanup function
    return function () {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', handleOrientationChange);
        if (resizeTimer)
            clearTimeout(resizeTimer);
    };
};
/**
 * Check if device supports dynamic viewport units
 */
export var supportsDynamicViewport = function () {
    return CSS.supports('height', '100dvh');
};
/**
 * Get the preferred viewport height unit
 */
export var getViewportHeightUnit = function () {
    return supportsDynamicViewport() ? '100dvh' : '100vh';
};
/**
 * Safely set viewport height on an element
 */
export var setElementViewportHeight = function (element) {
    if (supportsDynamicViewport()) {
        element.style.height = '100dvh';
    }
    else {
        element.style.height = 'calc(var(--vh, 1vh) * 100)';
    }
};
